<template>
    <div ref="fulLoader" class="full-loader" style="display: none">
        <div ref="backdrop" class="fade modal-backdrop" style="display: none"></div>
    </div>
</template>

<script>
    import mbModalFullLoader from "@dialogs/modalFullLoader";

    export default {
        mixins: [mbModalFullLoader]
    };
</script>

<style lang="scss" scoped>
    .full-loader {
        position: fixed;
        z-index: 1030;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        cursor: progress;
    }
</style>



// WEBPACK FOOTER //
// src/custom/mbstalas/dialogs/modalFullLoader.vue